import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from 'lodash';
import { Unidade } from 'src/app/core/unidade';
import { ToolbarPrincipalService } from 'src/app/services/toolbarPrincipal/toolbar-principal.service';
import { UnidadeService } from 'src/app/services/unidade/unidade.service';
import { Acesso } from "../../../core/acesso";
import { PlanejamentoOficina } from '../../../core/planejamento-oficina';
import { DataUtilService } from "../../../services/commons/data-util.service";
import { ComboProgramaComponent } from '../../common/combo-programa/combo-programa.component';
import { ComboProjetoComponent } from '../../common/combo-projeto/combo-projeto.component';

@Component({
  selector: 'dados-planejamento-oficina',
  templateUrl: './dados-planejamento-oficina.component.html',
  styleUrls: ['./dados-planejamento-oficina.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DadosPlanejamentoOficinaComponent implements OnInit, OnChanges {
  public mascaraHorario = [/\d/, /\d/, ':', /[0-5]/, /\d/];

  @Input() planejamentoOficina: PlanejamentoOficina;
  @Input() perfilAcesso: Acesso;

  @ViewChild('comboProgramaPorContrato', { static: false })
  comboProgramaPorContrato: ComboProgramaComponent;

  @ViewChild('comboProjetoPorContrato', { static: false })
  comboProjetoPorContrato: ComboProjetoComponent;

  unidades: Unidade[];

  tipoHorario: any = [
    { id: 'F', descricao: 'FIXO' },
    { id: 'L', descricao: 'LIVRE' },
  ];

  localExecucao: any = [
    { id: 'I', descricao: 'INTERNA' },
    { id: 'E', descricao: 'EXTERNA' },
  ];

  mostrarCampos = false;

  constructor(
    private toolbarPrincipalService: ToolbarPrincipalService,
    private unidadeService: UnidadeService,
    private dataUtilService: DataUtilService,
    private cdr: ChangeDetectorRef
    ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['planejamentoOficina'] && changes['planejamentoOficina'].currentValue) {
      
      this.cdr.detectChanges();
    }
  }

  ngOnInit() {
    this.mostrarCampos = false;

    this.unidadeService.getAllUnidadesUsuarioLogadoTemAcesso().subscribe((unidades: Unidade[]) => {
      this.unidades = unidades;
      if(!this.planejamentoOficina.unidade.idUnidade){
        this.planejamentoOficina.unidade = _.find(this.unidades, (u: Unidade) => u.idUnidade === this.toolbarPrincipalService.getUnidadeLogada().id);
      }
    });

  }

  onValorChangePrograma(registro: any) {
    this.planejamentoOficina.programa = registro;
  }

  onValorChangeProjeto(registro: any) {
    this.planejamentoOficina.projeto = registro;
  }

  onValorChangePercurso(registro: any) {
    this.planejamentoOficina.percurso = registro;
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  formatarCargaHoraria(): void {
    if (this.planejamentoOficina && this.planejamentoOficina.cargaHoraria != null) {
      this.planejamentoOficina.cargaHoraria = parseFloat(this.planejamentoOficina.cargaHoraria.toFixed(2));
    }
  }  

  atualizarCargaHoraria(valor: string): void {
    const valorNumerico = parseFloat(valor);
    if (!isNaN(valorNumerico)) {
      this.planejamentoOficina.cargaHoraria = parseFloat(valorNumerico.toFixed(2));
    } else {
      this.planejamentoOficina.cargaHoraria = null;
    }
  }  

  onTimeChange(value: string) {
    if (!value) {
      this.planejamentoOficina.cargaHoraria = null;
      return;
    }
  
    const [hh, mm] = value.split(':').map(Number);
  
    if (!isNaN(hh) && !isNaN(mm) && mm >= 0 && mm < 60) {
      this.planejamentoOficina.cargaHoraria = hh + mm / 60;
    }
  }

}
